<template>
  <a @click="triggerAction">
    <MButton> {{ $tc('cancel') }} {{ $tc('order') }} </MButton>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="times" class="w-full text-secondary-red" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_cancel', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </a>
</template>

<script>
import { StatusComputed } from '@state/modules/status'
import { getPurchaseStatusSystemName } from '../helpers/status'
export default {
  name: 'CancelPurchaseBtn',
  props: {
    moduleName: { type: String, required: true },
    updateApi: { type: Function, required: true },
    purchase: { type: Object, required: true },
  },
  data() {
    this.statusName = getPurchaseStatusSystemName
    return {
      showModal: false,
      processing: false,
    }
  },
  computed: {
    ...StatusComputed,
    cancleStatusId() {
      if (this[`${this.moduleName}FindStatus`]) {
        return this[`${this.moduleName}FindStatus`](
          this.statusName['cancelled']
        ).id
      }
      return undefined
    },
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.updateApi) {
        this.processing = true
        this.updateApi({ statusId: this.cancleStatusId })
          .then(() => {
            this.showModal = false
          })
          .finally(() => {
            this.showModal = false
            this.processing = false
          })
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
